import { CreditCard } from './__autogenerated__/types/CreditCard';

/**
 * Maps short codes to full CreditCard IDs
 * Format: 'CODE' -> 'FULL_CARD_ID'
 */
export const shortCodeToCardId: Record<string, CreditCard> = {
  // AARP Cards
  AARP: CreditCard.A_A_R_P_ESSENTIAL_REWARDS_MASTERCARD_FROM_BARCLAYS,
  AARPT: CreditCard.A_A_R_P_TRAVEL_REWARDS_MASTERCARD_FROM_BARCLAYS,

  // Alaska Airlines
  ALBZ: CreditCard.ALASKA_AIRLINES_BUSINESS_CREDIT_CARD,
  AS: CreditCard.ALASKA_AIRLINES_VISA_SIGNATURE,

  // Amex Cards
  BCE: CreditCard.BLUE_CASH_EVERYDAY_CARD_FROM_AMERICAN_EXPRESS_CARD,
  BCEP: CreditCard.AMERICAN_EXPRESS_BLUE_CASH_PREFERRED_CARD,
  BBP: CreditCard.BLUE_BUSINESS_PLUS_CREDIT_CARD,
  BCPBIZ: CreditCard.BLUE_BUSINESS_CASHTM_CARD,
  GOLD: CreditCard.AMERICAN_EXPRESS_GOLD_CARD,
  GR: CreditCard.AMERICAN_EXPRESS_GREEN_CARD,
  PLAT: CreditCard.AMERICAN_EXPRESS_THE_PLATINUM_CARD,
  BIZGOLD: CreditCard.BUSINESS_GOLD_CARD,
  BIZGR: CreditCard.BUSINESS_GREEN_REWARDS_CARD,
  BIZPLAT: CreditCard.BUSINESS_PLATINUM_CARD,

  // Apple
  AC: CreditCard.APPLE_CARD,

  // Chase Cards
  CFU: CreditCard.CHASE_FREEDOM_UNLIMITED_CREDIT_CARD,
  CFF: CreditCard.CHASE_FREEDOM_FLEX_CREDIT_CARD,
  CFR: CreditCard.CHASE_FREEDOM_RISE_CREDIT_CARD,
  CSP: CreditCard.CHASE_SAPPHIRE_PREFERRED_CREDIT_CARD,
  CSR: CreditCard.CHASE_SAPPHIRE_RESERVE_CREDIT_CARD,
  CSRB: CreditCard.CHASE_SAPPHIRE_RESERVE_FOR_BUSINESS_S_M_CREDIT_CARD,
  CSRB2: CreditCard.CHASE_THE_NEW_SAPPHIRE_RESERVE_FOR_BUSINESS_S_M_CREDIT_CARD,
  SWP: CreditCard.CHASE_SOUTHWEST_RAPID_REWARDS_PRIORITY_CREDIT_CARD,
  UEX: CreditCard.CHASE_UNITED_EXPLORER_CARD,
  UQG: CreditCard.CHASE_UNITED_GATEWAY_CREDIT_CARD,
  UQ: CreditCard.CHASE_UNITED_QUEST_CARD,
  UCB: CreditCard.CHASE_UNITED_CLUB_BUSINESS_CARD,
  UCLUB: CreditCard.CHASE_UNITED_CLUB_INFINITE_CARD,
  UBIZ: CreditCard.CHASE_UNITED_BUSINESS_CARD,
  INKC: CreditCard.INK_BUSINESS_CASH_CREDIT_CARD,
  INKP: CreditCard.INK_BUSINESS_PREFERRED_CREDIT_CARD,
  INKU: CreditCard.INK_BUSINESS_UNLIMITED_CREDIT_CARD,
  INKPRE: CreditCard.INK_BUSINESS_PREMIER_CREDIT_CARD,
  INST: CreditCard.CHASE_INSTACART_MASTERCARD,

  // Citi Cards
  CDC: CreditCard.CITI_DOUBLE_CASH_CARD,
  CCC: CreditCard.CITI_CUSTOM_CASH_CARD,
  CITIDP: CreditCard.CITI_DIAMOND_PREFERRED_CREDIT_CARD,
  CITIAAAX: CreditCard.CITI_AADVANTAGE_EXECUTIVE_WORLD_ELITE_MASTERCARD,
  CITIAAABUS: CreditCard.CITI_AADVANTAGE_BUSINESS_WORLD_ELITE_MASTERCARD,
  CITISTR: CreditCard.CITI_STRATA_CARD,
  CITISTREL: CreditCard.CITI_STRATA_ELITE_CARD,
  CITISTRP: CreditCard.CITI_STRATA_PREMIER_CARD,
  CITISEC: CreditCard.CITI_SECURED_MASTERCARD,
  CITISIM: CreditCard.CITI_SIMPLICITY_CREDIT_CARD,
  CITIPX: CreditCard.CITI_PRO_XTRA_CREDIT_CARD,
  ATTM: CreditCard.ATT_POINTS_PLUS_CARD_FROM_CITI,
  CITIRW: CreditCard.CITI_REWARDS_CREDIT_CARD,
  CITIRWS: CreditCard.CITI_REWARDS_STUDENT_CREDIT_CARD,
  CITITY: CreditCard.SHOP_YOUR_WAY_MASTERCARD,

  // Capital One Cards
  QS: CreditCard.QUICKSILVER_REWARDS,
  QS1: CreditCard.QUICKSILVERONE_REWARDS,
  QSGC: CreditCard.QUICKSILVER_REWARDS_FOR_GOOD_CREDIT,
  QSSTD: CreditCard.QUICKSILVER_REWARDS_FOR_STUDENTS,
  QSEC: CreditCard.QUICKSILVER_SECURED_REWARDS,
  VENTURE: CreditCard.VENTURE_REWARDS,
  VX: CreditCard.VENTURE_X_REWARDS,
  VXB: CreditCard.VENTURE_X_BUSINESS,
  VO: CreditCard.VENTUREONE_REWARDS,
  VOG: CreditCard.VENTUREONE_REWARDS_FOR_GOOD_CREDIT,
  SAVOR: CreditCard.SAVOR_REWARDS,
  SAVORG: CreditCard.SAVOR_REWARDS_FOR_GOOD_CREDIT,
  SAVORSTD: CreditCard.SAVOR_REWARDS_FOR_STUDENTS,
  SAVORONE: CreditCard.CAPITAL_ONE_SAVOR_ONE_REWARDS,
  SPARK2: CreditCard.SPARK_2_CASH,
  SPARK2P: CreditCard.SPARK_2_CASH_PLUS,
  SPARK2M: CreditCard.SPARK_2X_MILES,
  SPARKCLS: CreditCard.SPARK_CLASSIC,
  SPARK15C: CreditCard.SPARK_15_CASH_SELECT,
  SPARK15M: CreditCard.SPARK_15X_MILES_SELECT,

  // Bank of America Cards
  BOATR: CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS,
  BOATRS: CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS_FOR_STUDENTS,
  BOATR_SEC: CreditCard.BANK_OF_AMERICA_TRAVEL_REWARDS_SECURED,
  BOAPR: CreditCard.BANK_OF_AMERICA_PREMIUM_REWARDS,
  BOAPRE: CreditCard.BANK_OF_AMERICA_PREMIUM_REWARDS_ELITE,
  BOACCR: CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS,
  BOACCRS: CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_FOR_STUDENTS,
  BOACCRSEC: CreditCard.BANK_OF_AMERICA_CUSTOMIZED_CASH_REWARDS_SECURED,
  BOAUNLIM: CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS,
  BOAUNLIMSTD: CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_FOR_STUDENTS,
  BOAUNLIMSEC: CreditCard.BANK_OF_AMERICA_UNLIMITED_CASH_REWARDS_SECURED,
  BOAASCNT: CreditCard.BANK_OF_AMERICA_ATMOS_REWARDS_ASCENT_VISA_SIGNATURE_CARD,
  BOASMMT:
    CreditCard.BANK_OF_AMERICA_ATMOS_REWARDS_SUMMIT_VISA_INFINITE_CREDIT_CARD,
  BOABUS: CreditCard.BUSINESS_ADVANTAGE_TRAVEL_REWARDS_CREDIT_CARD,
  BOABUSCCR: CreditCard.BUSINESS_ADVANTAGE_CUSTOMIZED_CASH_REWARDS_CREDIT_CARD,
  BOABUSUNLIM: CreditCard.BUSINESS_ADVANTAGE_UNLIMITED_CASH_REWARDS_CREDIT_CARD,

  // Discover Cards
  DSCASH: CreditCard.DISCOVER_IT_CASH_BACK_CREDIT_CARD,
  DSMILES: CreditCard.DISCOVER_IT_MILES_CREDIT_CARD,
  DSCCHRO: CreditCard.DISCOVER_IT_CHROME_GAS_RESTAURANT_CREDIT_CARD,
  DSEC: CreditCard.DISCOVER_IT_SECURED_CREDIT_CARD,
  DSCSTD: CreditCard.DISCOVER_IT_STUDENT_CASH_BACK_CREDIT_CARD,
  DSCSTDCHRO: CreditCard.DISCOVER_IT_STUDENT_CHROME_CREDIT_CARD,
  DSCNHL: CreditCard.NHL_DISCOVER_IT_CREDIT_CARD,

  // Delta Cards
  DSB: CreditCard.DELTA_SKYMILES_BLUE_AMERICAN_EXPRESS_CARD,
  DSG: CreditCard.DELTA_SKYMILES_GOLD_AMERICAN_EXPRESS_CARD,
  DSGBUS: CreditCard.DELTA_SKYMILES_GOLD_BUSINESS_CARD,
  DSP: CreditCard.DELTA_SKYMILES_PLATINUM_AMERICAN_EXPRESS_CARD,
  DSPBUS: CreditCard.DELTA_SKYMILES_PLATINUM_BUSINESS_CARD,
  DSR: CreditCard.DELTA_SKYMILES_RESERVE_AMERICAN_EXPRESS_CARD,
  DSRBUS: CreditCard.DELTA_SKYMILES_RESERVE_BUSINESS_CARD,

  // US Bank Cards
  USBCASHSEC: CreditCard.US_BANK_CASH_SECURED_VISA_CARD,
  USBCASHVS: CreditCard.US_BANK_CASH_VISA_SIGNATURE_CARD,
  USBALTG: CreditCard.US_BANK_ALTITUDE_GO_VISA_SIGNATURE_CARD,
  USBALTG_SEC: CreditCard.US_BANK_ALTITUDE_GO_SECURED_VISA_CARD,
  USBALTC: CreditCard.US_BANK_ALTITUDE_CONNECT_VISA_SIGNATURE_CARD,
  USBSHOP: CreditCard.US_BANK_SHOPPER_CASH_REWARDS_VISA_SIGNATURE_CARD,
  USBSMART: CreditCard.US_BANK_SMARTLY_VISA_SIGNATURE_CARD,
  USBSEC: CreditCard.US_BANK_SECURED_VISA_CARD,
  USBALTR: CreditCard.US_BANK_ALTITUDE_RESERVE_VISA_INFINITE_CARD,

  // Amex Airlines
  AAMILE: CreditCard.AMERICAN_AIRLINES_AADVANTAGE_MILEUP_CARD,
  AAPLAT:
    CreditCard.AMERICAN_AIRLINES_AADVANTAGE_PLATINUM_SELECT_WORLD_ELITE_MASTERCARD,
  AAVE1: CreditCard.AADVANTAGEAVIATORRED_WORLD_ELITE_MASTERCARD,

  // Southwest Cards
  SWPLUS: CreditCard.SOUTHWEST_RAPID_REWARDS_PLUS_CREDIT_CARD,
  SWPRE: CreditCard.SOUTHWEST_RAPID_REWARDS_PREMIER_CREDIT_CARD,
  SWPERFBUS:
    CreditCard.SOUTHWEST_RAPID_REWARDS_PERFORMANCE_BUSINESS_CREDIT_CARD,
  SWPREBUS: CreditCard.SOUTHWEST_RAPID_REWARDS_PREMIER_BUSINESS_CREDIT_CARD,

  // United Cards (standalone)
  UCLUBBUS: CreditCard.UNITED_CLUB_BUSINESS_CARD,
  UGW: CreditCard.UNITED_GATEWAY_CREDIT_CARD,
  UBUS: CreditCard.UNITED_BUSINESS_CARD,

  // Marriott Cards
  MARBOLD: CreditCard.MARRIOTT_BONVOY_BOLD_CREDIT_CARD,
  MARBOUND: CreditCard.MARRIOTT_BONVOY_BOUNDLESS_CREDIT_CARD,
  MARBRIL: CreditCard.MARRIOTT_BONVOY_BRILLIANT_AMERICAN_EXPRESS_CARD,
  MARBUNTI: CreditCard.MARRIOTT_BONVOY_BOUNTIFUL_CREDIT_CARD,
  MARBUS: CreditCard.MARRIOTT_BONVOY_BUSINESS_CARD,
  MARBEVY: CreditCard.MARRIOTT_BONVOY_BEVY_AMERICAN_EXPRESS_CARD,

  // Hilton Cards
  HHLT: CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_CARD,
  HHLTS: CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_SURPASS_CARD,
  HHASPR: CreditCard.HILTON_HONORS_AMERICAN_EXPRESS_ASPIRE_CARD,
  HHBT: CreditCard.HILTON_HONORS_BUSINESS_CARD,

  // Hyatt Cards
  WOH: CreditCard.WORLD_OF_HYATT_CREDIT_CARD,
  WOHBUS: CreditCard.WORLD_OF_HYATT_BUSINESS_CREDIT_CARD,

  // IHG Cards
  IHGPR: CreditCard.IHG_ONE_REWARDS_PREMIER_CREDIT_CARD,
  IHGBUS: CreditCard.IHG_ONE_REWARDS_PREMIER_BUSINESS_CREDIT_CARD,
  IHGTRV: CreditCard.IHG_ONE_REWARDS_TRAVELER_CREDIT_CARD,

  // Wyndham Cards
  WYEARN: CreditCard.WYNDHAM_REWARDS_EARNERCARD,
  WYEARNPLUS: CreditCard.WYNDHAM_REWARDS_EARNER_PLUS_CARD,
  WYEARNBUS: CreditCard.WYNDHAM_REWARDS_EARNER_BUSINESS_CARD,

  // JetBlue Cards
  JB: CreditCard.JETBLUE_CARD,
  JBP: CreditCard.JETBLUE_PLUS_CARD,
  JBBUS: CreditCard.JETBLUE_BUSINESS_CARD,

  // Alaska Airlines (standalone entries)
  ASBIZ: CreditCard.ALASKA_AIRLINES_BUSINESS_CREDIT_CARD,

  // Other Popular Cards
  RH: CreditCard.ROBINHOOD_CARD,
  RHPLAT: CreditCard.ROBINHOOD_PLATINUM_CARD,
  VEN: CreditCard.VENMO_VISA_CREDIT_CARD,
  BILT: CreditCard.BILT_MASTERCARD,
  BILTB: CreditCard.BILT_BLUE_CARD,
  BILTO: CreditCard.BILT_OBSIDIAN_CARD,
  BILTP: CreditCard.BILT_PALLADIUM_CARD,
  AUTH_CARD: CreditCard.AUTOGRAPH_CARD,
  AUTH_JRN: CreditCard.AUTOGRAPH_JOURNEY_CARD,

  // Costco
  COSTCO: CreditCard.COSTCO_ANYWHERE_VISA_CARD_BY_CITI,
  COSTCOB: CreditCard.COSTCO_ANYWHERE_VISA_BUSINESS_CARD_BY_CITI,

  // Amazon
  AMZN_VISA: CreditCard.AMAZON_VISA,
  AMZN_BUS: CreditCard.AMAZON_BUSINESS_CARD,
  AMZN_BUS_PR: CreditCard.AMAZON_BUSINESS_PRIME_CARD,

  // Verizon
  VZW: CreditCard.VERIZON_VISA_CARD,

  // Wells Fargo
  WFONE: CreditCard.WELLS_FARGO_ONE_KEY_CARD,
  WFAUTH: CreditCard.AUTOGRAPH_CARD,
  WFAUTH_JRN: CreditCard.AUTOGRAPH_JOURNEY_CARD,
  WFACT: CreditCard.ACTIVE_CASH_CARD,
  WFREFL: CreditCard.REFLECT_CARD,
  WFREE: CreditCard.REFLECT_CARD, // Duplicate code for REFLECT_CARD

  // Doordash
  DDM: CreditCard.DOORDASH_REWARDS_MASTERCARD,

  // Barclays
  GMBUS: CreditCard.BARCLAYS_G_M_BUSINESS_MASTERCARD,
  GMC: CreditCard.BARCLAYS_G_M_REWARDS_MASTERCARD,
  CARNIV: CreditCard.BARCLAYS_CARNIVAL_WORLD_MASTERCARD,
  JBPR: CreditCard.BARCLAYS_JET_BLUE_PREMIER_CARD,

  // Disney
  DISNPREM: CreditCard.DISNEY_PREMIER_VISA_CARD,
  DISN: CreditCard.DISNEY_VISA_CARD,

  // Amazon
  PRIME_VISA: CreditCard.PRIME_VISA,

  // Bank of America misc
  BAMERICARD: CreditCard.BANKAMERICARD,
  BAMERICARDSTD: CreditCard.BANKAMERICARD_FOR_STUDENTS,
  BAMERICARDSEC: CreditCard.BANKAMERICARD_SECURED,

  // Citibank misc
  CITIMACS: CreditCard.CITI_MACYS_CREDIT_CARDS,

  // Royal Caribbean
  ROYAL: CreditCard.ROYAL_CARIBBEAN_VISA_SIGNATURE,
  CELEB: CreditCard.CELEBRITY_CRUISES_VISA_SIGNATURE,
  NORW: CreditCard.NORWEGIAN_CRUISE_LINE_WORLD_MASTERCARD,

  // Other cards
  LLBEAN: CreditCard.LL_BEAN_MASTERCARD,
  BANANARE: CreditCard.BANANA_REPUBLIC_REWARDS_MASTERCARD,
  GAP: CreditCard.GAP_GOOD_REWARDS_MASTERCARD,
  ATHLET: CreditCard.ATHLETA_REWARDS_MASTERCARD,

  // Home Depot
  HD: CreditCard.THE_HOME_DEPOT_CONSUMER_CREDIT_CARD,

  // Other airlines
  HAW: CreditCard.HAWAIIAN_AIRLINES_WORLD_ELITE_MASTERCARD,
  HAWB: CreditCard.HAWAIIAN_AIRLINES_WORLD_ELITE_BUSINESS_MASTERCARD,
  FRNT: CreditCard.FRONTIER_AIRLINES_WORLD_MASTERCARD,
  BREEZE: CreditCard.BREEZE_EASYVISA_CREDIT_CARD,

  // Hotels
  CHOICE: CreditCard.CHOICE_PRIVILEGES_MASTERCARD,
  CHOICESEL: CreditCard.CHOICE_PRIVILEGES_SELECT_MASTERCARD,

  // Cruises (duplicate removed - already defined above as CARNIV)

  // Store cards
  BASS: CreditCard.BASS_PRO_SHOPS_CLUB_CARD,
  CABEL: CreditCard.CABELAS_CLUB_CARD,
  BNB: CreditCard.BARNES_NOBLE_MASTERCARD,

  // Other
  PLUM: CreditCard.PLUM_CARD,
  ATTUNE: CreditCard.ATTUNE_CARD,
  AMEXED: CreditCard.AMEX_EVERYDAY_CREDIT_CARD_AMERICAN_EXPRESS_CARD,

  // HSBC
  HSBCE: CreditCard.HSBC_ELITE_CREDIT_CARD,
  HSBCP: CreditCard.HSBC_PREMIER_CREDIT_CARD,

  // Barclays
  UPROM: CreditCard.UPROMISEWORLD_MASTERCARD,

  // Citi Travel (duplicate removed - already defined above as CITISTRP)

  // Iberia
  IB: CreditCard.IBERIA_VISA_SIGNATURE_CREDIT_CARD,

  // British Airways
  BA: CreditCard.BRITISH_AIRWAYS_VISA_SIGNATURE_CREDIT_CARD,

  // Emirates
  EMRATPR: CreditCard.EMIRATES_SKYWARDS_PREMIUM_WORLD_ELITE_MASTERCARD,
  EMRAT: CreditCard.EMIRATES_SKYWARDS_REWARDS_WORLD_ELITE_MASTERCARD,

  // Air France KLM
  AFKLM: CreditCard.AIR_FRANCE_KLM_WORLD_ELITE_MASTERCARD,
  AER: CreditCard.AER_LINGUS_VISA_SIGNATURE_CREDIT_CARD,
  AEROP: CreditCard.AEROPLAN_CARD,

  // Spirit
  SPRIT: CreditCard.FREE_SPIRIT_TRAVEL_MORE_WORLD_ELITE_MASTERCARD,

  // Bilt (duplicate removed - already defined above as BILT)

  // Navy Federal
  NAVY: CreditCard.NAVYIST_REWARDS_MASTERCARD,
  NFFLAG: CreditCard.NAVY_FEDERAL_FLAGSHIP_VISA_SIGNATURE,

  // Capital One Vacation
  CAPVAC: CreditCard.CAPITAL_VACATIONSWORLD_MASTERCARD,

  // Walmart
  TSC: CreditCard.TSC_CREDIT_CARDS,
  COWMT: CreditCard.CAPITAL_ONE_WALMART_REWARDS_MASTERCARD,

  // AAA
  AAADA: CreditCard.AAA_DAILY_ADVANTAGE_VISA_SIGNATURE,
  AAATA: CreditCard.AAA_TRAVEL_ADVANTAGE_VISA_SIGNATURE,

  // PenFed
  PFPATH: CreditCard.PENFED_PATHFINDER_REWARDS_VISA_SIGNATURE,

  // Grocery Store Cards
  KROG: CreditCard.KROGER_REWARDS_WORLD_ELITE_MASTERCARD,
  HT: CreditCard.HARRIS_TEETER_REWARDS_WORLD_ELITE_MASTERCARD,
  RLPH: CreditCard.RALPHS_REWARDS_WORLD_ELITE_MASTERCARD,

  // Target
  TGT: CreditCard.TARGET_CIRCLE_CARD,

  // PayPal
  PPCB: CreditCard.SYNCHRONY_PAY_PAL_CASHBACK_WORLD_MASTERCARD,

  // Credit Unions
  RDFCU: CreditCard.REDSTONE_FCU_VISA_SIGNATURE,
  GSCU: CreditCard.GREENSTATE_CU_WORLD_MASTERCARD,

  // FNBO
  DU: CreditCard.DUCKS_UNLIMITED_REWARDS_VISA,

  // Sam's Club
  SAMS: CreditCard.SAMS_CLUB_CREDIT_CARD,

  // Bread / Comenity
  BREAD: CreditCard.BREAD_REWARDS_AMERICAN_EXPRESS_CARD,

  // BMO
  BMOCB: CreditCard.BMO_CASH_BACK_MASTERCARD,

  // Truist
  TRUIST: CreditCard.TRUIST_ENJOY_CASH_CREDIT_CARD,

  // PNC
  PNCCR: CreditCard.PNC_CASH_REWARDS_VISA,

  // USAA
  USAACB: CreditCard.USAA_CASHBACK_REWARDS_PLUS,

  // Huntington
  HUNTBIZ: CreditCard.HUNTINGTON_VOICE_BUSINESS_MASTERCARD,

  // Elan
  ELANMCP: CreditCard.ELAN_MAX_CASH_PREFERRED_VISA,
  ELANERP: CreditCard.ELAN_EVERYDAY_REWARDS_PLUS,
};

/**
 * Reverse lookup map: card ID -> short code
 */
export const cardIdToShortCode: Record<CreditCard, string> = Object.fromEntries(
  Object.entries(shortCodeToCardId).map(([code, cardId]) => [cardId, code])
) as Record<CreditCard, string>;

/**
 * Encodes a card ID to its short code, or returns the full ID if no short code exists
 */
export function cardIdToShort(cardId: CreditCard): string {
  return cardIdToShortCode[cardId] || cardId;
}

/**
 * Decodes a short code to its full card ID, or returns the input if it's already a full ID
 */
export function shortToCardId(input: string): CreditCard {
  return shortCodeToCardId[input] || (input as CreditCard);
}

/**
 * Checks if a string looks like a short code (uppercase, short, alphanumeric)
 */
export function isShortCode(input: string): boolean {
  return (
    input.length <= 20 &&
    input === input.toUpperCase() &&
    /^[A-Z0-9_]+$/.test(input)
  );
}
